export default __webpack_public_path__ + "static/media/arrownext.7a34c824.svg";